<template>
  <header class="usage-terms-header">
    <router-link :to="usageTermsRoute"
                 tag="button"
                 class="btn btn-primary btn-extra-round">
      {{$t('message.termsOfUse.message.registerTermOfUse')}}
    </router-link>

    <i
        v-if="isEstablishment"
        class="mdi mdi-account-plus-outline  data-controller-icon"
        v-tooltip="$t('message.termsOfUse.message.dataController')"
        @click="openUserDataControllerModal"
    ></i>

    <UseTermsDataControllerModal
        v-if="userDataController"
        v-model="isDataControllerModalOpen"
        :user-data-controller="userDataController"
    ></UseTermsDataControllerModal>
  </header>
</template>

<script>
import UseTermsDataControllerModal from "./UseTermsDataControllerModal.vue";

export default {
    components: {
        UseTermsDataControllerModal
    },

    data(){
        return {
            isDataControllerModalOpen: false,
            userDataController: null
        }
    },

    computed: {
        usageTermsRoute() {
            return this.isAdmin ? '/admin/termos-de-uso/cadastrar' : '/termos-de-uso/cadastrar'
        },
        isAdmin() {
            return this.$store.state.users.admin && !this.$store.state.users.user
        },
        isEstablishment() {
            return this.$store.state.users.user && this.$store.state.users.user.tipo === "ESTABELECIMENTO"
        }
    },

    methods: {
        async openUserDataControllerModal(){
            await this.getUserDataController();

            this.isDataControllerModalOpen = true
        },

        async getUserDataController() {
            try {
                const response = await this.$api.dataController.get();

                Object.keys(response).forEach(key => {
                    if(response[key] === null){
                        response[key] = ''
                    }
                })

                this.userDataController = response
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.usage-terms-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.data-controller-icon {
    font-size: 24px;
    color: #707070;
    padding: 4px;
    cursor: pointer;
}
</style>
